import React from 'react';

class MultiSortableTableHeader extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.sortCaret = this.sortCaret.bind(this);
    }

    sortCaret(sortProperty) {
        if (sortProperty === this.props.propertyToSortBy) {
            if (this.props.sortDirection === 'asc') {
                return (<i className="fa fa-caret-up"></i>);
            } else {
                return (<i className="fa fa-caret-down"></i>)
            }
        }
    }

    render() {
        return (
                <th>
                    {this.props.sortProperties.map((property) => {
                        return (
                                <span style={{cursor: "pointer"}}
                                      onClick={() => this.props.updateSortProperty(property.sortProperty)}
                                      title={"Nach " + property.sortPropertyName + " sortieren"}
                                      key={property.sortPropertyName}
                                >{property.sortPropertyName} {this.sortCaret(property.sortProperty)}<br/></span>)
                    })}
                </th>
        )
    }
}

export default MultiSortableTableHeader


// WEBPACK FOOTER //
// ./src/admin/components/MultiSortableTableHeader.js